export enum TipoFaseViabilidadeEnum {
  Aquisicao = 1,
  Estudo = 2,
  Projeto = 3,
  PreLancamento = 4,
  Lancamento = 5
}

export const TipoFaseViabilidadeLabel = new Map<number, string>([
  [TipoFaseViabilidadeEnum.Aquisicao, 'Aquisição'],
  [TipoFaseViabilidadeEnum.Estudo, 'Estudo'],
  [TipoFaseViabilidadeEnum.Projeto, 'Projeto'],
  [TipoFaseViabilidadeEnum.PreLancamento, 'Pré-lançamento'],
  [TipoFaseViabilidadeEnum.Lancamento, 'Lançamento']
])
